import { partnerQueryKeys as e } from "./usePartnerQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { partnerApplicationsApi as r } from "@maat/api-main";
//#region src/partners/useSavePartnerApplicationMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.save(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.application() });
		}
	});
};
//#endregion
export { i as useSavePartnerApplicationMutation };
